import axios from "axios";
import React, { useState, useEffect, useRef, useContext } from "react";
import { FieldInputProps } from "formik";
import { Link } from "react-router-dom";
import { KTSVG } from "../../_metronic/helpers";
import Select from "react-select";
import { Editor } from "@tinymce/tinymce-react";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

import { MessageContext } from "../../_metronic/layout/core";
import moment from "moment";
import "./mobile-select-styles.css";
const API_URL = process.env.REACT_APP_API_URL;
const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const getE = async () => {
  let dataArr = [] as any;
  await axios.get(`${API_URL}event/all/admin`).then(async (json) => {
    json.data.data = json.data.data
      .sort((a: any, b: any) => (a.title < b.title ? 1 : -1))
      .sort((a: any, b: any) =>
        parseInt(moment(a.startDate).format("x")) <
        parseInt(moment(b.startDate).format("x"))
          ? 1
          : -1
      );

    await json.data.data.map((ele: any, index: any) => {
      ele.title = `${moment(ele.startDate).format("DD MMM YYYY")} - ${
        ele.title
      }`;
      return ele;
    });
    dataArr = await json.data.data;
  });
  return dataArr;
};

export const slugifyVar = {
  replacement: "-",
  lower: true,
  strict: true,
};
export const customStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    color: state.isSelected ? "white" : "blue",
    minHeight: "50px", // Default taller for all devices initially
    padding: "10px 12px",
    whiteSpace: "normal", // Allow wrapping by default
    lineHeight: "1.4",
    wordWrap: "break-word",
    display: "flex",
    alignItems: "flex-start",
    fontSize: "0.95rem",
  }),
  control: (provided: any) => ({
    ...provided,
    backgroundColor: "#F5F8FA",
    borderColor: "#F5F8FA",
    color: "#5E6278",
    transition: "color 0.2s ease, background-color 0.2s ease",
    padding: "0.325rem 1rem",
    fontSize: "1.15rem",
    borderRadius: "0.475rem",
    minHeight: "45px", // Slightly taller control
  }),
  singleValue: (provided: any, state: any) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";
    return { ...provided, opacity, transition };
  },
  menu: (provided: any) => ({
    ...provided,
    zIndex: "90",
  }),
  menuList: (provided: any) => ({
    ...provided,
    maxHeight: "250px", // Reasonable height for mobile
  }),
  multiValue: (provided: any) => ({
    ...provided,
    fontWeight: "500",
  }),
};

// For backward compatibility, create function version too
export const getCustomStyles = () => customStyles;

export enum DataStatus {
  Active = "active",
  Inactive = "inactive",
}
export enum DataFeature {
  Yes = "yes",
  No = "no",
}
export enum StatusValue {
  Yes = "yes",
  No = "no",
}

export enum DataCategory {
  Mangla = "mangla",
  Sandhya = "sandhya",
  Chesta = "chesta",
}

export type idProps = {
  id?: string;
  adminPath?: string;
  addData?: any;
  handleLinkClick?: any;
  title?: any;
  pdf_title?: any;
  link?: any;
};
export type tabProps = {
  id?: string;
  handleData?: any;
  showData?: string;
  ImageGallery?: string;
  CMSContent?: string;
  url?: string;
  SectionContent?: string;
  ShowMetaTab?: string;
  IssectionDetailsShow?: string;
  AudioShow?: string;
};
export type tabLiProps = {
  id?: string;
  first?: string;
  handleData?: any;
  showData?: string;
  title?: string;
  value?: string;
  url?: string;
};
export type OrderProps = {
  required?: string;
  size?: string;
  value?: FieldInputProps<any>;
  title?: string;
  touchedName?: boolean;
  errorsName?: string;
  Cid?: string;
  OrderMenu?: Array<any>;
};
export type SelectProps = {
  formik?: any;
  size?: string;
  value?: FieldInputProps<any>;
  placeholder?: string;
  touchedName?: boolean;
  errorsName?: string;
  Cid?: string;
  isRoot?: string;
  multiple?: string;
  DataArr?: Array<any>;
  handleChange?: any;
  name?: any;
  Index?: any;
  otherData?: any;
  MyHandleChange?: string;
};
export const FeatureArr = [
  { _id: "yes", name: "Yes" },
  { _id: "no", name: "No" },
];
export const GalleryTypeArr = [
  { _id: "yes", name: "WhatsApp" },
  { _id: "no", name: "News" },
];
export const CategoryArr = [
  { _id: "mangla", name: "Mangla" },
  { _id: "sandhya", name: "Sandhya" },
  { _id: "chesta", name: "Chesta" },
];
export const CategoryKatha = [
  { _id: "daily_routine", name: "Daily Routine" },
  { _id: "Naadvansh", name: "Naadvansh" },
  { _id: "Philosophy", name: "Philosophy" },
  { _id: "Sarvopari Upasana", name: "Sarvopari Upasana" },
  {
    _id: "Shree Swaminarayan Gadi Granth",
    name: "Shree Swaminarayan Gadi Granth",
  },
  { _id: "Swaminarayan Bhagwan Mahima", name: "Swaminarayan Bhagwan Mahima" },
  { _id: "Vachanamrut", name: "Vachanamrut" },
  { _id: "Ways of Life", name: "Ways of Life" },
];
export const handleVoid = () => {};
export const CurdHeader: React.FC<idProps> = ({
  id,
  adminPath,
  addData,
  handleLinkClick,
  title = "",
  pdf_title = "",
  link = "",
}) => {
  const [bool, setbool] = useState(false);
  useEffect(() => {
    if (id == undefined) {
      setbool(true);
      // addData(bool)
    }
  }, [bool]);
  return (
    <>
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bolder fs-3 mb-1">
            {link == "#clone" ? "Clone" : id !== undefined ? "Edit" : "Add"}{" "}
            {link !== "" && (title !== "" || pdf_title !== "") && (
              <a href={`${link}`} target="_blank">
                {title !== ""
                  ? `Website Link - ${title}`
                  : `PDF Link - ${pdf_title}`}
              </a>
            )}
          </span>
        </h3>

        <div className="card-toolbar">
          <Link
            to={`/${adminPath}list`}
            onClick={handleLinkClick}
            className="btn btn-sm btn-light-primary"
          >
            <KTSVG
              path="/media/icons/duotune/general/gen025.svg"
              className="svg-icon-4"
            />
            List
          </Link>
        </div>
      </div>
    </>
  );
};

export const TabHeader: React.FC<tabProps> = ({
  id,
  handleData,
  showData,
  ImageGallery,
  CMSContent,
  url,
  SectionContent,
  ShowMetaTab = "1",
  AudioShow = "0",
}) => {
  let isFirst = "yes";
  return (
    <>
      <div className="d-flex overflow-auto h-55px">
        <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold flex-nowrap">
          <TabLi
            first="yes"
            id={id}
            handleData={handleData}
            showData={showData}
            url={url}
            title="Basic Information"
            value="basic"
          />
          {SectionContent === "1" ? (
            <TabLi
              first="no"
              id={id}
              handleData={handleData}
              showData={showData}
              url={url}
              title="Section"
              value="sectionInfo"
            />
          ) : (
            <></>
          )}
          {CMSContent === "1" ? (
            <TabLi
              first="no"
              id={id}
              handleData={handleData}
              showData={showData}
              url={url}
              title="Content"
              value="content"
            />
          ) : (
            <></>
          )}
          {AudioShow === "1" ? (
            <TabLi
              first="no"
              id={id}
              handleData={handleData}
              showData={showData}
              url={url}
              title="Audio"
              value="audio"
            />
          ) : (
            <></>
          )}
          {ShowMetaTab === "1" ? (
            <TabLi
              first="no"
              id={id}
              handleData={handleData}
              showData={showData}
              url={url}
              title="Meta Data"
              value="meta"
            />
          ) : (
            <></>
          )}
          {ImageGallery === "1" ? (
            <TabLi
              first="no"
              id={id}
              handleData={handleData}
              showData={showData}
              url={url}
              title="Image Gallery"
              value="image_gallery"
            />
          ) : (
            <></>
          )}
        </ul>
      </div>
    </>
  );
};

export const TabHeaderSection: React.FC<tabProps> = ({
  id,
  handleData,
  showData,
  ImageGallery,
  CMSContent,
  url,
  SectionContent,
  IssectionDetailsShow = "1",
}) => {
  let isFirst = "yes";
  return (
    <>
      <div className="d-flex overflow-auto h-55px">
        <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold flex-nowrap">
          {IssectionDetailsShow === "1" ? (
            <TabLi
              first="yes"
              id={id}
              handleData={handleData}
              showData={showData}
              url={url}
              title="Section Information"
              value="basicsection"
            />
          ) : (
            <></>
          )}
          <TabLi
            first={IssectionDetailsShow === "1" ? "no" : "yes"}
            id={id}
            handleData={handleData}
            showData={showData}
            url={url}
            title="Chapter List"
            value="chaptureList"
          />
        </ul>
      </div>
    </>
  );
};

export const TabLi: React.FC<tabLiProps> = ({
  first,
  id,
  handleData,
  showData,
  title,
  value,
  url,
}) => {
  return (
    <>
      {first === "yes" ? (
        <li
          className="nav-item"
          style={{ marginLeft: "30px", cursor: "pointer" }}
          onClick={(e) => handleData(value)}
        >
          {url !== "" && url !== undefined ? (
            <Link
              to={`/${url}${id}/${value}`}
              className={
                `nav-link text-active-primary me-6 ` +
                (showData === value && " active ")
              }
            >
              {title}
            </Link>
          ) : (
            <span
              className={
                `nav-link text-active-primary me-6 ` +
                (showData === value && " active ")
              }
            >
              {title}
            </span>
          )}
        </li>
      ) : (
        <li
          className="nav-item"
          style={
            id !== undefined
              ? { cursor: "pointer" }
              : { opacity: "0.5", pointerEvents: "none" }
          }
          onClick={
            id !== undefined ? (e) => handleData(value) : (e) => () => {}
          }
        >
          {url !== "" && url !== undefined ? (
            <Link
              to={`/${url}${id}/${value}`}
              className={
                `nav-link me-6 ` +
                (showData === value && " active ") +
                (id !== undefined && " text-active-primary ")
              }
            >
              {title}
            </Link>
          ) : (
            <span
              className={
                `nav-link me-6 ` +
                (showData === value && " active ") +
                (id !== undefined && " text-active-primary ")
              }
            >
              {title}
            </span>
          )}
        </li>
      )}
    </>
  );
};

export const ErrorBlock: React.FC<any> = ({ touchedName, errorsName }) => {
  return (
    <>
      {touchedName && errorsName && (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block text-danger">{errorsName}</div>
        </div>
      )}
    </>
  );
};
export const SeparatorBlock: React.FC<any> = ({ title }) => {
  return (
    <>
      {title && (
        <>
          <div className="text-primary fw-bold fs-4 mb-3 text-danger mt-6">
            {title}
          </div>
          <div className="separator separator-dashed"></div>
        </>
      )}
    </>
  );
};

export const InputTextareaNode: React.FC<any> = ({
  size,
  value,
  placeholder,
  touchedName,
  errorsName,
  onchange,
  formik,
}) => {
  value.value =
    value.value !== "undefined" &&
    value.value !== undefined &&
    value.value !== ""
      ? value.value
      : "";
  const handleChange = (opop: any) => {
    formik.setFieldValue(value.name, opop);
  };
  const [_GKey, setGKey] = useState("");

  useEffect(() => {
    if (_GKey == "") {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}global/editor-key/670e40f0cc837d6373e07ec6`
        )
        .then((json) => {
          setGKey(
            json?.data?.data[0]?.editorKey != "" &&
              json?.data?.data[0]?.editorKey != undefined
              ? json?.data?.data[0]?.editorKey
              : "q4xjrooanmd996w5s4g289idbx2xdzl16a3bs9arwmn7ygsu"
          );
        });
    }
  }, []);
  const today = new Date();
  return (
    <>
      <div className={`col-lg-${size} fv-row`}>
        {_GKey != "" ? (
          <>
            <Editor
              onEditorChange={handleChange}
              apiKey={_GKey}
              value={value.value}
              // onChange={onchangeText}
              textareaName={value.name}
              init={{
                branding: false,
                height: 300,
                menubar: true,
                convert_unsafe_embeds: false,
                sandbox_iframes: false,
                plugins: [
                  "advlist",
                  "autolink",
                  "lists",
                  "link",
                  "image",
                  "charmap",
                  "anchor",
                  "searchreplace",
                  "visualblocks",
                  "code",
                  "fullscreen",
                  "insertdatetime",
                  "media",
                  "table",
                  "preview",
                  "wordcount",
                ],
                toolbar:
                  "undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
                content_style:
                  "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
              }}
            />
          </>
        ) : (
          <></>
        )}
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};

export const InputTextNode: React.FC<any> = ({
  size,
  value,
  placeholder,
  touchedName,
  errorsName,
}) => {
  value.value =
    value.value !== "undefined" &&
    value.value !== undefined &&
    value.value !== ""
      ? value.value
      : "";
  return (
    <>
      <div className={`col-lg-${size} fv-row`}>
        <input
          type="text"
          className="form-control form-control-lg form-control-solid"
          placeholder={placeholder}
          {...value}
        />
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};

export const InputNumberNode: React.FC<any> = ({
  size,
  value,
  placeholder,
  touchedName,
  errorsName,
}) => {
  return (
    <>
      <div className={`col-lg-${size} fv-row`}>
        <input
          type="number"
          className="form-control form-control-lg form-control-solid"
          placeholder={placeholder}
          {...value}
        />
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};

export const InputNumberChangeNode: React.FC<any> = ({
  size,
  value,
  placeholder,
  touchedName,
  errorsName,
  handleChange,
}) => {
  return (
    <>
      <div className={`col-lg-${size} fv-row`}>
        <input
          type="number"
          className="form-control form-control-lg form-control-solid"
          placeholder={placeholder}
          {...value}
          onChange={(e) => handleChange(e)}
        />
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};

export const InputTextChangeNode: React.FC<any> = ({
  size,
  value,
  placeholder,
  handleChange,
  touchedName,
  errorsName,
  index,
}) => {
  return (
    <>
      <div className={`col-lg-${size} fv-row`}>
        <input
          type="text"
          className="form-control form-control-lg form-control-solid"
          placeholder={placeholder}
          {...value}
          onChange={(e) => handleChange(e)}
        />
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};

export const InputColorNode: React.FC<any> = ({
  size,
  value,
  placeholder,
  touchedName,
  errorsName,
}) => {
  return (
    <>
      <div className={`col-lg-${size} fv-row`}>
        <input
          type="color"
          className="form-control form-control-lg form-control-solid"
          placeholder={placeholder}
          {...value}
        />
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};

export const InputDateNode: React.FC<any> = ({
  size,
  value,
  placeholder,
  touchedName,
  errorsName,
  maxDate,
}) => {
  return (
    <>
      <div className={`col-lg-${size} fv-row`}>
        <input
          type="date"
          className="form-control form-control-lg form-control-solid"
          placeholder={placeholder}
          {...value}
          max={maxDate}
        />
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};
export const InputTimeNode: React.FC<any> = ({
  size,
  value,
  placeholder,
  touchedName,
  errorsName,
}) => {
  return (
    <>
      <div className={`col-lg-${size} fv-row`}>
        <input
          type="time"
          className="form-control form-control-lg form-control-solid"
          placeholder={placeholder}
          {...value}
        />
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};

export const InputSelectNode: React.FC<SelectProps> = ({
  size,
  value,
  placeholder,
  touchedName,
  errorsName,
  DataArr,
  Cid,
  name,
  handleChange,
  isRoot,
  Index,
  otherData,
}) => {
  let options: any[] = [];
  if (isRoot === "1") {
    options.push({ value: "0", label: "/" });
  } else if (isRoot === "-1") {
  } else {
  }
  {
    DataArr &&
      DataArr.map(({ _id, name, title }) =>
        _id !== Cid
          ? options.push({
              value: _id,
              label: name === undefined ? title : name,
            })
          : ""
      );
  }

  return (
    <>
      <div className={`col-lg-${size} fv-row`}>
        <Select
          styles={getCustomStyles()}
          className="mobile-friendly-select"
          classNamePrefix="mobile-select"
          options={options as any}
          value={options.find((item) => item.value === value?.value)}
          onChange={(e) => handleChange(e.value, Index, otherData)}
          name={value?.name}
          placeholder={"Select " + placeholder}
        />
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};

export const InputMultiSelectNode: React.FC<SelectProps> = ({
  formik,
  size,
  value,
  placeholder,
  touchedName,
  errorsName,
  DataArr,
  Cid,
  isRoot,
  handleChange,
  MyHandleChange = "0",
  Index,
  otherData,
}) => {
  let options: any[] = [];
  /* (isRoot === '1') ? options.push({value: '0',label:'/'}) : ((isRoot === '-1')?'': options.push({value: '',label:'Select '+placeholder})) */
  if (isRoot === "1") {
    options.push({ value: "0", label: "/" });
  } else if (isRoot === "-1") {
  } else {
    //options.push({value: '',label:'Select '+placeholder})
  }

  {
    DataArr &&
      DataArr.map(({ _id, name, title, band }) =>
        _id !== Cid
          ? options.push({
              value: _id,
              label:
                name === undefined
                  ? title === undefined
                    ? band
                    : title
                  : name,
            })
          : ""
      );
  }
  const SelectedData = (opop: any) => {
    if (opop === undefined || opop === "" || opop.length === 0) {
      return [];
    }
    let typeOpop = typeof opop;
    opop = typeOpop === "string" ? opop.split(",") : opop;
    let optionsSelected_: any[] = [];
    opop.forEach((id: any) => {
      let __singleopt_ = options.find((el) => el.value === id);
      if (__singleopt_ !== undefined) {
        let parent_menu =
          options !== undefined && options.length > 0 ? __singleopt_.label : "";
        optionsSelected_.push({ value: id, label: parent_menu });
      }
    });
    return optionsSelected_.filter(
      (ele, ind) =>
        ind === optionsSelected_.findIndex((elem) => elem.value === ele.value)
    );
  };

  const handleGlobalTag = (_value: any) => {
    let selectedTag: any[] = [];
    {
      _value && _value.map((dsa: any) => selectedTag.push(dsa.value));
    }
    formik.setFieldValue(value?.name, selectedTag);
  };

  return (
    <>
      <div className={`col-lg-${size} fv-row`} key={`${Index}fdsfds`}>
        <Select
          isMulti
          styles={getCustomStyles()}
          className="mobile-friendly-select"
          classNamePrefix="mobile-select"
          options={options as any}
          name={value?.name}
          value={SelectedData(value?.value)}
          onChange={
            MyHandleChange === "1"
              ? (e) => handleChange(e, Index, otherData)
              : handleGlobalTag
          }
          placeholder={"Select " + placeholder}
          key={`${Index}select-box-multi`}
        />
        {/* <select className='form-control form-control-lg form-control-solid' {...value} multiple >
          {(isRoot === "1") ? (<option value="0" key={0}>/</option>) : ((isRoot === "-1") ? (<></>) : (<option value="" key={0}>Select {placeholder}</option>))}
          {DataArr && DataArr.map(({ _id, name }) => (_id !== Cid) ? <option value={_id} key={_id}>{name}</option> : '')}
        </select> */}
        <ErrorBlock
          touchedName={touchedName}
          errorsName={errorsName}
          key={`${Index}error`}
        />
      </div>
    </>
  );
};

export const InputCheckboxIndexNode: React.FC<any> = ({
  size,
  value,
  renderValue,
  handleChange,
  index,
}) => {
  return (
    <>
      <div className={`col-lg-${size} d-flex align-items-center`}>
        <div className="form-check form-check-solid form-switch fv-row">
          <input
            className="form-check-input w-45px h-30px"
            type="checkbox"
            checked={renderValue === "active" ? true : false}
            {...value}
            onChange={(e) => handleChange(index)}
          />
          <label className="form-check-label"></label>
        </div>
      </div>
    </>
  );
};

export const InputCheckboxNode: React.FC<any> = ({
  size,
  value,
  renderValue,
  handleChange,
  disabled,
}) => {
  return (
    <>
      <div className={`col-lg-${size} d-flex align-items-center`}>
        <div className="form-check form-check-solid form-switch fv-row">
          <input
            className="form-check-input w-45px h-30px"
            type="checkbox"
            checked={renderValue === "active" ? true : false}
            {...value}
            disabled={disabled}
            onChange={(e) => handleChange(e)}
          />
          <label className="form-check-label"></label>
        </div>
      </div>
    </>
  );
};

export const InputImagesNode: React.FC<any> = ({
  size,
  name,
  placeholder,
  touchedName,
  errorsName,
  handleChange,
  removeChange,
  image_path,
  type = "image",
  index = 0,
  type_id = "",
  otherData,
}) => {
  return (
    <>
      <div className={`col-lg-${size}`}>
        <label className="col-form-label fw-bold fs-6 text-color-active">
          {placeholder}
        </label>
        <input
          type="file"
          name={name}
          id={name}
          accept={
            type === "image"
              ? "image/*"
              : type === "video"
              ? "video/*"
              : type === "pdf"
              ? "application/pdf"
              : ""
          }
          className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
          onClick={(e: any) => (e.target.value = null)}
          onChange={(e) => {
            handleChange(e, index as any, type_id as any);
          }}
          style={{ display: "none" }}
        />

        <label
          htmlFor={name}
          className=" btn btn-light-primary fs-6 card flex-center bg-light-primary border-primary border border-dashed p-3"
        >
          <span>
            <KTSVG
              path="/media/svg/files/upload.svg"
              className="svg-icon-2 mb-2"
            />{" "}
            Attach {placeholder}
          </span>
        </label>
        {image_path !== "" &&
          image_path !== undefined &&
          (!otherData || otherData !== "undefined") && (
            <div
              className="col-8 mt-3 image_node"
              style={{
                width: "190px",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                padding: "5px 5px 5px 10px",
              }}
            >
              <div>
                <i
                  className="fa fa-trash"
                  id={`remove-${name}`}
                  onClick={(e) => removeChange(e, index as any, type_id as any)}
                />
              </div>
              {type === "image" ? (
                <img
                  className="img-fluid "
                  src={image_path}
                  id={`preview-${name}`}
                  alt=""
                />
              ) : (
                <>
                  <a
                    href={`${image_path}`}
                    target="_blank"
                    className={`text-active-primary fs-6`}
                  >
                    Click here for view file
                  </a>
                </>
              )}
            </div>
          )}
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};

export const MenuInputImagesNode: React.FC<any> = ({
  size,
  name,
  placeholder,
  touchedName,
  errorsName,
  handleChange,
  removeChange,
  image_path,
  type = "image",
  index = 0,
  type_id = "",
}) => {
  return (
    <>
      <div className={`col-lg-${size}`}>
        <input
          type="file"
          name={name}
          id={name}
          accept={
            type === "image"
              ? "image/*"
              : type === "pdf"
              ? "application/pdf"
              : ""
          }
          className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
          onChange={(e) => handleChange(e, index as any, type_id as any)}
          style={{ display: "none" }}
        />

        <label
          htmlFor={name}
          className=" btn btn-light-primary fs-6 card flex-center bg-light-primary border-primary border border-dashed p-3"
        >
          <span>
            <KTSVG
              path="/media/svg/files/upload.svg"
              className="svg-icon-2 mb-2"
            />{" "}
            Attach {placeholder}
          </span>
        </label>
        {image_path !== "" && image_path !== undefined && (
          <div
            className="col-8 mt-3 image_node"
            style={{
              width: "190px",
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
              padding: "5px 5px 5px 10px",
            }}
          >
            <div>
              <i
                className="fa fa-trash"
                id={`remove-${name}`}
                onClick={(e) => removeChange(e, index as any, type_id as any)}
              />
            </div>
            {type === "image" ? (
              <img
                className="img-fluid "
                src={image_path}
                id={`preview-${name}`}
                alt=""
              />
            ) : (
              <>
                <a
                  href={`${image_path}`}
                  target="_blank"
                  className={`text-active-primary fs-6`}
                >
                  Click here for view file
                </a>
              </>
            )}
          </div>
        )}
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};
export const InputImagesMultipleNode: React.FC<any> = ({
  size,
  name,
  placeholder,
  touchedName,
  errorsName,
  handleChange,
  image_path,
}) => {
  return (
    <>
      <div className={`col-lg-${size}`}>
        <label className="col-form-label fw-bold fs-6 text-color-active">
          {placeholder}
        </label>
        <input
          type="file"
          name={name}
          id={name}
          accept=".gif,.jpg,.jpeg,.png,.svg"
          //  accept='image/*'
          className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
          onChange={(e) => handleChange(e)}
          style={{ display: "none" }}
          multiple
        />

        <label
          htmlFor={name}
          className=" btn btn-light-primary fs-6 card flex-center bg-light-primary border-primary border border-dashed p-3"
        >
          <span>
            <KTSVG
              path="/media/svg/files/upload.svg"
              className="svg-icon-2 mb-2"
            />{" "}
            Click to add images
          </span>
        </label>
        <div className="row">
          {image_path &&
            image_path.map((value: any) => (
              <div className="col-3 mt-3">
                <img className="img-fluid " src={value.image_path} alt="" />
              </div>
            ))}
        </div>
        <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
      </div>
    </>
  );
};

export const CurdName: React.FC<any> = ({
  formik,
  slugVisible,
  handleName,
}) => {
  return (
    <>
      <div className="row mb-6">
        <div className="col-md-4">
          <label className="col-lg-12 col-form-label required fw-bold fs-6">
            Name
          </label>
          <InputTextChangeNode
            size="12"
            placeholder="Name"
            value={formik.getFieldProps("name")}
            touchedName={formik.touched.name}
            errorsName={formik.errors.name}
            handleChange={handleName}
          />
        </div>
        {slugVisible === "1" ? (
          <div className="col-md-4">
            <label className="col-lg-12 col-form-label required fw-bold fs-6">
              Slug
            </label>
            <InputTextNode
              size="12"
              placeholder="Slug"
              value={formik.getFieldProps("slug")}
              touchedName={formik.touched.slug}
              errorsName={formik.errors.slug}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export const CurdTitle: React.FC<any> = ({
  formik,
  categoryVisible,
  Category,
  CategoryText = "Category",
  handleCategory,
  genreVisible = "0",
  Genre,
  handleGenre,
  globalTagVisible,
  GlobalTag,
  handleGlobalTag,
  ISBN,
  handleDesc,
  descVisible = "1",
  gujTitleVisible = "0",
  gujDescVisible = "0",
  titleHandel = "0",
  SortTitleVisible = "0",
  gujsortTitleVisible = "0",
  handleName,
  slugVisible,
  slugWebVisible = "0",
}) => {
  return (
    <>
      <SeparatorBlock size="6" title="Details" />
      <div className="row mb-6">
        <div className="col-lg-12">
          <label className="col-form-label required fw-bold fs-6 text-color-active">
            Title
          </label>
          {titleHandel === "0" ? (
            <InputTextNode
              size="12"
              placeholder="Title"
              value={formik.getFieldProps("title")}
              touchedName={formik.touched.title}
              errorsName={formik.errors.title}
            />
          ) : (
            <>
              <InputTextChangeNode
                size="12"
                placeholder="Title"
                value={formik.getFieldProps("title")}
                touchedName={formik.touched.title}
                errorsName={formik.errors.title}
                handleChange={handleName}
              />
              {slugVisible === "1" ? (
                <div className="col-md-12">
                  <label className="col-lg-12 col-form-label required fw-bold fs-6">
                    Slug
                  </label>
                  <InputTextNode
                    size="12"
                    placeholder="Slug"
                    value={formik.getFieldProps("slug")}
                    touchedName={formik.touched.slug}
                    errorsName={formik.errors.slug}
                  />
                </div>
              ) : (
                <></>
              )}
              {slugWebVisible === "1" ? (
                <div className="col-md-12">
                  <label className="col-lg-12 col-form-label required fw-bold fs-6">
                    Slug
                  </label>
                  <InputTextNode
                    size="12"
                    placeholder="Slug"
                    value={formik.getFieldProps("web_slug")}
                    touchedName={formik.touched.web_slug}
                    errorsName={formik.errors.web_slug}
                  />
                </div>
              ) : (
                <></>
              )}
            </>
          )}

          {gujTitleVisible === "1" ? (
            <div className="col-lg-12">
              <label className="col-form-label fw-bold fs-6 text-color-active">
                Gujarati Title
              </label>
              <InputTextNode
                size="12"
                placeholder="Gujarati Title"
                value={formik.getFieldProps("guj_title")}
                touchedName={formik.touched.guj_title}
                errorsName={formik.errors.guj_title}
              />
            </div>
          ) : (
            <></>
          )}
          {SortTitleVisible === "1" ? (
            <div className="col-lg-12">
              <label className="col-form-label required fw-bold fs-6 text-color-active">
                Sort Title{" "}
                <span style={{ fontSize: "11px", color: "#F1416C" }}>
                  (Only required when title is more than 50 characters)
                </span>
              </label>
              <InputTextNode
                size="12"
                placeholder="Sort Title"
                value={formik.getFieldProps("sort_title")}
                touchedName={formik.touched.sort_title}
                errorsName={formik.errors.sort_title}
              />
            </div>
          ) : (
            <></>
          )}
          {gujsortTitleVisible === "1" ? (
            <div className="col-lg-12">
              <label className="col-form-label required fw-bold fs-6 text-color-active">
                Gujarati Sort Title{" "}
                <span style={{ fontSize: "11px", color: "#F1416C" }}>
                  (Only required when title is more than 50 characters)
                </span>
              </label>
              <InputTextNode
                size="12"
                placeholder="Sort Title"
                value={formik.getFieldProps("guj_sort_title")}
                touchedName={formik.touched.guj_sort_title}
                errorsName={formik.errors.guj_sort_title}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        {categoryVisible === "1" ? (
          <div className="col-lg-6">
            <label className="col-form-label required fw-bold fs-6 text-color-active">
              {CategoryText !== "" || CategoryText !== undefined
                ? CategoryText
                : "Category"}
            </label>
            <InputSelectNode
              size="12"
              placeholder={
                CategoryText !== "" || CategoryText !== undefined
                  ? CategoryText
                  : "Category"
              }
              value={formik.getFieldProps("category")}
              touchedName={formik.touched.category}
              errorsName={formik.errors.category}
              DataArr={Category}
              Cid="0"
              name="category"
              handleChange={handleCategory}
              isRoot="-1"
            />
          </div>
        ) : (
          <></>
        )}
        {categoryVisible === "multiCategory" ? (
          <div className="col-lg-6">
            <label className="col-form-label required fw-bold fs-6 text-color-active">
              {CategoryText !== "" || CategoryText !== undefined
                ? CategoryText
                : "Category"}
            </label>
            <InputMultiSelectNode
              size="12"
              placeholder={
                CategoryText !== "" || CategoryText !== undefined
                  ? CategoryText
                  : "Category"
              }
              value={formik.getFieldProps("category")}
              touchedName={formik.touched.category}
              errorsName={formik.errors.category}
              MyHandleChange={"1"}
              DataArr={Category}
              Cid="0"
              handleChange={handleCategory}
              isRoot="-1"
            />
          </div>
        ) : (
          <></>
        )}

        {categoryVisible === "artist" ? (
          <div className="col-lg-6">
            <label className="col-form-label required fw-bold fs-6 text-color-active">
              {CategoryText !== "" || CategoryText !== undefined
                ? CategoryText
                : "Category"}
            </label>
            <InputMultiSelectNode
              size="12"
              placeholder={
                CategoryText !== "" || CategoryText !== undefined
                  ? CategoryText
                  : "Category"
              }
              value={formik.getFieldProps("type")}
              touchedName={formik.touched.type}
              errorsName={formik.errors.type}
              DataArr={Category}
              Cid="0"
              handleChange={handleCategory}
              isRoot="-1"
              formik={formik}
            />
          </div>
        ) : (
          <></>
        )}

        {categoryVisible === "2" ? (
          <div className="col-lg-6">
            <label className="col-form-label required fw-bold fs-6 text-color-active">
              Region
            </label>
            <InputSelectNode
              size="12"
              placeholder="Region"
              value={formik.getFieldProps("region")}
              touchedName={formik.touched.region}
              errorsName={formik.errors.region}
              DataArr={Category}
              // Cid={Cid}
              handleChange={handleCategory}
              isRoot="-1"
            />
          </div>
        ) : (
          <></>
        )}
        {genreVisible === "1" ? (
          <div className="col-lg-6">
            <label className="col-form-label fw-bold fs-6 text-color-active">
              Genre
            </label>
            <InputMultiSelectNode
              size="12"
              placeholder="Genre"
              value={formik.getFieldProps("genre")}
              touchedName={formik.touched.genre}
              errorsName={formik.errors.genre}
              MyHandleChange={"1"}
              DataArr={Genre}
              Cid="0"
              handleChange={handleGenre}
              isRoot="-1"
            />
          </div>
        ) : (
          <></>
        )}
        {globalTagVisible === "1" ? (
          <div className="col-lg-6">
            <label className="col-form-label fw-bold fs-6 text-color-active required">
              Global Tag
            </label>
            <InputMultiSelectNode
              size="12"
              placeholder="Global Tag"
              value={formik.getFieldProps("g_tag")}
              touchedName={formik.touched.g_tag}
              errorsName={formik.errors.g_tag}
              DataArr={GlobalTag}
              Cid="0"
              handleChange={handleGlobalTag}
              isRoot="-1"
              formik={formik}
            />
          </div>
        ) : (
          <></>
        )}

        {ISBN === "1" ? (
          <div className="col-lg-6">
            <label className="col-form-label fw-bold fs-6 text-color-active">
              ISBN No.
            </label>
            <InputTextNode
              size="12"
              placeholder="ISBN No."
              value={formik.getFieldProps("isbn")}
              touchedName={formik.touched.isbn}
              errorsName={formik.errors.isbn}
            />
          </div>
        ) : (
          <></>
        )}

        {/* <div className='col-lg-4'>
          <label className='col-form-label fw-bold fs-6 text-color-active'>Alert Tagline</label>
          <InputTextNode size="12" placeholder='Alert Tagline' value={formik.getFieldProps('tagline')} touchedName={formik.touched.tagline} errorsName={formik.errors.tagline} />
        </div> */}
        {descVisible === "1" ? (
          <div className="col-lg-12">
            <label className="col-form-label fw-bold fs-6 text-color-active">
              Description
            </label>
            <InputTextareaNode
              size="12"
              placeholder="Description"
              value={formik.getFieldProps("desc")}
              touchedName={formik.touched.desc}
              errorsName={formik.errors.desc}
              onchange={handleDesc}
              formik={formik}
            />
          </div>
        ) : (
          <></>
        )}

        {gujDescVisible === "1" ? (
          <div className="col-lg-12">
            <label className="col-form-label fw-bold fs-6 text-color-active">
              Gujarati Description
            </label>
            <InputTextareaNode
              size="12"
              placeholder="Gujarati Description"
              value={formik.getFieldProps("guj_desc")}
              touchedName={formik.touched.guj_desc}
              errorsName={formik.errors.guj_desc}
              formik={formik}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export const CurdTitleCMSContent: React.FC<any> = ({
  formik,
  handleType,
  Type,
  Align,
  handleAlign,
}) => {
  return (
    <>
      <SeparatorBlock size="6" title="Details" />
      <div className="row mb-6">
        <div className="col-lg-4">
          <label className="col-form-label required fw-bold fs-6 text-color-active">
            Type
          </label>
          <InputSelectNode
            size="12"
            placeholder="Type"
            value={formik.getFieldProps("type")}
            touchedName={formik.touched.type}
            errorsName={formik.errors.type}
            DataArr={Type}
            Cid="0"
            handleChange={handleType}
            isRoot="-1"
          />
        </div>

        <div className="col-lg-4">
          <label className="col-form-label fw-bold fs-6 text-color-active">
            Align
          </label>
          <InputSelectNode
            size="12"
            placeholder="Align"
            value={formik.getFieldProps("align")}
            touchedName={formik.touched.align}
            errorsName={formik.errors.align}
            DataArr={Align}
            handleChange={handleAlign}
            Cid="0"
            isRoot="-1"
          />
        </div>

        <div className="col-lg-4">
          <label className="col-form-label fw-bold fs-6 text-color-active">
            Title
          </label>
          <InputTextNode
            size="12"
            placeholder="Title"
            value={formik.getFieldProps("title")}
            touchedName={formik.touched.title}
            errorsName={formik.errors.title}
          />
        </div>
      </div>
    </>
  );
};

export const CurdDates: React.FC<any> = ({
  formik,
  startDateGujCalendar,
  endDate,
  endDateGujCalendar,
}) => {
  return (
    <>
      <div className="row mb-6">
        <div className="col-lg-4">
          <label className="col-form-label required fw-bold fs-6 text-color-active">
            Start Date
          </label>
          <InputDateNode
            size="12"
            placeholder="Start Date"
            value={formik.getFieldProps("startDate")}
            touchedName={formik.touched.startDate}
            errorsName={formik.errors.startDate}
          />
        </div>
        {startDateGujCalendar === "1" ? (
          <div className="col-lg-4">
            <label className="col-form-label fw-bold fs-6 text-color-active">
              Start Date Gujarati Calendar
            </label>
            <InputTextNode
              size="12"
              placeholder="Start Date Gujarati Calendar"
              value={formik.getFieldProps("startDateGujCalendar")}
              touchedName={formik.touched.startDateGujCalendar}
              errorsName={formik.errors.startDateGujCalendar}
            />
          </div>
        ) : (
          <></>
        )}
        {endDate === "1" ? (
          <div className="col-lg-4">
            <label className="col-form-label required fw-bold fs-6 text-color-active">
              End Date
            </label>
            <InputDateNode
              size="12"
              placeholder="End Date"
              value={formik.getFieldProps("endDate")}
              touchedName={formik.touched.endDate}
              errorsName={formik.errors.endDate}
            />
          </div>
        ) : (
          <></>
        )}
        {endDateGujCalendar === "1" ? (
          <div className="col-lg-4">
            <label className="col-form-label fw-bold fs-6 text-color-active">
              End Date Gujarati Calendar
            </label>
            <InputTextNode
              size="12"
              placeholder="End Date Gujarati Calendar"
              value={formik.getFieldProps("endDateGujCalendar")}
              touchedName={formik.touched.endDateGujCalendar}
              errorsName={formik.errors.endDateGujCalendar}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export const CurdPublishOn: React.FC<any> = ({
  formik,
  calendarGujarati,
  globalLocation,
  GlobalLocation,
  handleGlobalLocation,
  EventShow = "1",
  events,
  EventDateShow = "1",
  EventTimeShow = "0",
  PublishDateShow = "0",
  LocationInfoShow = "0",
}) => {
  return (
    <>
      <div className="row mb-6">
        <div className="col-lg-4">
          <label className="col-form-label fw-bold fs-6 text-color-active">
            Publish on
          </label>
          <InputDateNode
            size="12"
            placeholder="Publish on"
            value={formik.getFieldProps("publishOn")}
            touchedName={formik.touched.publishOn}
            errorsName={formik.errors.publishOn}
          />
        </div>
        {PublishDateShow === "1" ? (
          <div className="col-lg-4">
            <label className="col-form-label fw-bold fs-6 text-color-active">
              Publish Time
            </label>
            <InputTimeNode
              size="12"
              placeholder="Publish Time"
              value={formik.getFieldProps("publishTime")}
              touchedName={formik.touched.publishTime}
              errorsName={formik.errors.publishTime}
            />
          </div>
        ) : (
          ""
        )}
        {EventDateShow === "1" ? (
          <div className="col-lg-4">
            <label className="col-form-label fw-bold fs-6 text-color-active">
              Event Date
            </label>
            <InputDateNode
              size="12"
              placeholder="Event Date"
              value={formik.getFieldProps("eventDate")}
              touchedName={formik.touched.eventDate}
              errorsName={formik.errors.eventDate}
            />
          </div>
        ) : (
          ""
        )}
        {EventTimeShow === "1" ? (
          <div className="col-lg-4">
            <label className="col-form-label fw-bold fs-6 text-color-active">
              Event Time
            </label>
            <InputTimeNode
              size="12"
              placeholder="Event Time"
              value={formik.getFieldProps("eventTime")}
              touchedName={formik.touched.eventTime}
              errorsName={formik.errors.eventTime}
            />
          </div>
        ) : (
          ""
        )}
        {/* {(calendarGujarati === "1") ? (
          <div className='col-lg-4'>
            <label className='col-form-label fw-bold fs-6 text-color-active'>Publish on Gujarati Calendar</label>
            <InputTextNode size="12" placeholder='Publish on Gujarati Calendar' value={formik.getFieldProps('publishOnGujCalendar')} touchedName={formik.touched.publishOnGujCalendar} errorsName={formik.errors.publishOnGujCalendar} />
          </div>
        ) : (<></>)} */}
        {globalLocation === "1" ? (
          <div className="col-lg-4">
            <label className="col-form-label fw-bold fs-6 text-color-active">
              Event Location{" "}
              {LocationInfoShow === "2" ? (
                <span style={{ fontSize: "11px", color: "#F1416C" }}>
                  (The First tagged event location's website url will be
                  applied.)
                </span>
              ) : (
                ""
              )}{" "}
            </label>
            <InputSelectNode
              size="12"
              placeholder="Event Location"
              value={formik.getFieldProps("publishLocation")}
              touchedName={formik.touched.publishLocation}
              errorsName={formik.errors.publishLocation}
              DataArr={GlobalLocation}
              Cid="0"
              handleChange={handleGlobalLocation}
              isRoot="0"
            />
          </div>
        ) : (
          <></>
        )}

        {EventShow === "1" ? (
          <div className="col-lg-4">
            <label className="col-form-label fw-bold fs-6 text-color-active">
              Events
            </label>
            <InputMultiSelectNode
              size="12"
              value={formik.getFieldProps(`event_id`)}
              placeholder="Events"
              DataArr={events}
              Cid={`0`}
              isRoot="0"
              formik={formik}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export const InputTextWrapper: React.FC<any> = ({
  required,
  size,
  value,
  title,
  touchedName,
  placeholder,
  errorsName,
}) => {
  size = size === undefined ? "8" : size;
  return (
    <>
      <div className="row mb-6">
        <label
          className={`col-lg-12 col-form-label ${
            required !== "0" ? "required" : ""
          } fw-bold fs-6`}
        >
          {title}
        </label>
        <InputTextNode
          size={size}
          placeholder={placeholder ?? title}
          value={value}
          touchedName={touchedName}
          errorsName={errorsName}
        />
      </div>
    </>
  );
};

export const InputTextChangeWrapper: React.FC<any> = ({
  required,
  size,
  value,
  title,
  touchedName,
  errorsName,
  handleChange,
}) => {
  size = size === undefined ? "8" : size;
  return (
    <>
      <div className="row mb-6">
        <label
          className={`col-lg-12 col-form-label ${
            required !== "0" ? "required" : ""
          } fw-bold fs-6`}
        >
          {title}
        </label>
        <InputTextChangeNode
          size={size}
          placeholder={title}
          value={value}
          touchedName={touchedName}
          errorsName={errorsName}
          handleChange={handleChange}
        />
      </div>
    </>
  );
};

export const InputTextareaWrapper: React.FC<any> = ({
  required,
  size,
  value,
  title,
  touchedName,
  errorsName,
  formik,
}) => {
  size = size === undefined ? "8" : size;
  return (
    <>
      <div className="row mb-6">
        <label
          className={`col-12 col-form-label ${
            required !== "0" ? "required" : ""
          } fw-bold fs-6`}
        >
          {title}
        </label>
        <InputTextareaNode
          size={size}
          placeholder={title}
          value={value}
          touchedName={touchedName}
          errorsName={errorsName}
          formik={formik}
        />
      </div>
    </>
  );
};

export const InputTextareaWrapperSimple: React.FC<any> = ({
  required,
  size,
  value,
  title,
  touchedName,
  errorsName,
  formik,
}) => {
  size = size === undefined ? "8" : size;
  return (
    <>
      <div className="row mb-6">
        <label
          className={`col-12 col-form-label ${
            required !== "0" ? "required" : ""
          } fw-bold fs-6`}
        >
          {title}
        </label>
        <div className="col-12">
          <textarea
            type="hidden"
            rows="3"
            className="form-control form-control-lg form-control-solid"
            placeholder={title}
            {...value}
          />
        </div>
      </div>
    </>
  );
};

export const InputRadioWrapper: React.FC<{
  name: string;
  value: string;
  label: string;
  checked: boolean;
  onChange: (value: string) => void;
}> = ({ name, value, label, checked, onChange }) => {
  return (
    <div className="form-check form-check-custom form-check-solid me-10 mb-3">
      <input
        className="form-check-input"
        type="radio"
        name={name}
        id={`${name}-${value}`}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
      />
      <label className="form-check-label" htmlFor={`${name}-${value}`}>
        {label}
      </label>
    </div>
  );
};

export interface SelectOption {
  _id: string;
  name: string;
}

interface InputSelectWrapperProps {
  value: any;
  title: string;
  touchedName?: boolean;
  errorsName?: string;
  DataArr?: SelectOption[]; // Use the defined interface
  Cid?: string;
  handleChange: (value: string) => void;
  isRoot?: string;
  size?: string;
  required?: string;
  loading?: boolean;
}

export const InputSelectWrapperLoader: React.FC<InputSelectWrapperProps> = ({
  value,
  title,
  touchedName,
  errorsName,
  DataArr,
  Cid,
  handleChange,
  isRoot,
  size = "12",
  required = "0",
  loading = false, // Add loading prop
  ...props
}) => {
  return (
    <div className={`col-lg-${size} col-md-${size} col-sm-12 mb-4 mb-md-0`}>
      <div className="form-group">
        <label
          className={`col-form-label ${
            required === "1" ? "required" : ""
          } fw-bold fs-6`}
        >
          {title}
        </label>

        {loading ? (
          <div className="d-flex align-items-center">
            <span className="spinner-border spinner-border-sm me-3" />
            Loading options...
          </div>
        ) : (
          <select
            className={`form-select form-select-solid form-select-lg ${
              touchedName && errorsName ? "is-invalid" : ""
            }`}
            value={value.value}
            onChange={(e) => handleChange(e.target.value)}
            {...props}
          >
            <option value="">Select {title}</option>
            {DataArr &&
              DataArr.map((option) => (
                <option key={option._id} value={option._id}>
                  {option.name}
                </option>
              ))}
          </select>
        )}

        {touchedName && errorsName && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block text-danger">{errorsName}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export const InputSelectWrapper: React.FC<any> = ({
  required,
  size,
  value,
  title,
  placeholder,
  touchedName,
  errorsName,
  DataArr,
  Cid,
  handleChange,
  isRoot,
  Index,
  otherData,
}) => {
  size = size === undefined ? "8" : size;
  return (
    <>
      <div className="row mb-6">
        <label
          className={`col-lg-12 col-form-label ${
            required !== "0" ? "required" : ""
          } fw-bold fs-6`}
        >
          {title}
        </label>
        <InputSelectNode
          size={size}
          placeholder={placeholder ?? title}
          value={value}
          touchedName={touchedName}
          errorsName={errorsName}
          DataArr={DataArr}
          Cid={Cid}
          handleChange={handleChange}
          isRoot={isRoot}
          Index={Index}
          otherData={otherData}
        />
      </div>
    </>
  );
};

export const MenuSelectWrapper: React.FC<any> = ({
  required,
  size,
  value,
  title,
  touchedName,
  errorsName,
  DataArr,
  Cid,
  handleChange,
  isRoot,
  Index,
  otherData,
}) => {
  size = size === undefined ? "8" : size;
  return (
    <>
      <div className="row mb-6">
        <InputSelectNode
          size={size}
          placeholder={title}
          value={value}
          touchedName={touchedName}
          errorsName={errorsName}
          DataArr={DataArr}
          Cid={Cid}
          handleChange={handleChange}
          isRoot={isRoot}
          Index={Index}
          otherData={otherData}
        />
      </div>
    </>
  );
};

export const InputCheckboxWrapper: React.FC<any> = ({
  required,
  size,
  value,
  renderValue,
  handleChange,
  title,
  disabled,
}) => {
  size = size === undefined ? "8" : size;
  return (
    <>
      <div className="row mb-6">
        <label
          className={`col-lg-12 col-form-label ${
            required !== "0" ? "required" : ""
          } fw-bold fs-6`}
        >
          {title}
        </label>
        <InputCheckboxNode
          size={size}
          value={value}
          renderValue={renderValue}
          handleChange={handleChange}
          disabled={disabled}
        />
      </div>
    </>
  );
};

export const InputSwitch: React.FC<{
  required: string;
  name: string;
  checked: boolean;
  onChange: () => void;
  title: string;
}> = ({ required, name, checked, onChange, title }) => {
  return (
    <div className="row mb-6">
      <label
        className={`col-lg-12 col-form-label ${
          required !== "0" ? "required" : ""
        } fw-bold fs-6`}
      >
        {title}
      </label>
      <div className="col-lg-12">
        <div className="form-check form-switch form-check-custom form-check-solid">
          <input
            className="form-check-input"
            type="checkbox"
            name={name}
            id={name}
            checked={checked}
            onChange={onChange}
            role="switch"
          />
        </div>
      </div>
    </div>
  );
};

export const InputCheckboxIndexWrapper: React.FC<any> = ({
  required,
  size,
  value,
  renderValue,
  handleChange,
  title,
  index,
}) => {
  size = size === undefined ? "8" : size;
  return (
    <>
      <div className="row mb-6">
        <label
          className={`col-lg-12 col-form-label ${
            required !== "0" ? "required" : ""
          } fw-bold fs-6`}
        >
          {title}
        </label>
        <InputCheckboxIndexNode
          size={size}
          value={value}
          renderValue={renderValue}
          handleChange={handleChange}
          index={index}
        />
      </div>
    </>
  );
};

export const InputDisplayOrder0NameNode: React.FC<OrderProps> = ({
  required,
  size,
  value,
  title,
  touchedName,
  errorsName,
  OrderMenu,
  Cid,
}) => {
  size = size === undefined ? "8" : size;
  return (
    <>
      <div className="row mb-6">
        <label
          className={`col-12 col-form-label ${
            required !== "0" ? "required" : ""
          } fw-bold fs-6`}
        >
          {title}
        </label>
        <div className={`col-lg-${size} fv-row`}>
          <select
            className="form-control form-control-lg form-control-solid"
            {...value}
          >
            <option value="0" key={0}>
              /
            </option>
            {OrderMenu &&
              OrderMenu.map(
                (
                  {
                    _id,
                    name,
                    title,
                    displayOrder,
                    sound_cloud_id,
                    gujarati_title,
                    author,
                    band,
                  },
                  index: number
                ) =>
                  _id !== Cid ? (
                    <option value={displayOrder + 1} key={index}>
                      {index + 1} {`=>`} {name} {title} {sound_cloud_id}{" "}
                      {gujarati_title} {author} {band}
                    </option>
                  ) : (
                    ""
                  )
              )}
          </select>
          <ErrorBlock touchedName={touchedName} errorsName={errorsName} />
        </div>
      </div>
    </>
  );
};

export const InputSubmitWrapper: React.FC<{
  loading: boolean;
  buttonName?: string;
}> = ({ loading, buttonName }) => {
  return (
    <div className="card-footer d-flex justify-content-end py-6 px-9">
      <button type="submit" className="btn btn-primary" disabled={loading}>
        {!loading && (buttonName || "Save Changes")}
        {loading && (
          <span className="indicator-progress" style={{ display: "block" }}>
            Please wait...{" "}
            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        )}
      </button>
    </div>
  );
};

export function SubmitCurd(
  navigate?: any,
  values?: any,
  API_URL?: string,
  apiPath?: string,
  adminPath?: string,
  id?: string,
  ISList?: string
) {
  delete values._id;
  delete values.__v;
  if (id !== undefined) {
    delete values.createdDate;
    delete values.createdBy;
    delete values.updatedBy;
    delete values.updatedDate;
    delete values.deleted;
    return axios
      .put(`${API_URL}${apiPath}${id}`, values)
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        return err.response.data;
      });
  } else {
    return axios
      .post(`${API_URL}${apiPath}`, values)
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        return err.response.data;
      });
  }
  return true;
}

export function SubmitFileCurd(
  navigate?: any,
  values?: any,
  API_URL?: string,
  apiPath?: string,
  adminPath?: string,
  id?: string
) {
  if (id !== undefined) {
    return axios
      .put(`${API_URL}${apiPath}file/${id}`, values, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function (progressEvent: any) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          console.log(percentCompleted);
        },
      })
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        return err.response.data;
      });
  } else {
    return axios
      .post(`${API_URL}${apiPath}file/`, values, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        return err.response.data;
      });
  }
}

export function SubmitFileCurdProgress(
  navigate?: any,
  values?: any,
  API_URL?: string,
  apiPath?: string,
  adminPath?: string,
  id?: string,
  setProgress?: any
) {
  if (id !== undefined) {
    return axios
      .put(`${API_URL}${apiPath}file/${id}`, values, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function (progressEvent: any) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        },
      })
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        return err.response.data;
      });
  } else {
    return axios
      .post(`${API_URL}${apiPath}file/`, values, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function (progressEvent: any) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        },
      })
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        return err.response.data;
      });
  }
}

export function SubmitFileCurd1(
  navigate?: any,
  values?: any,
  API_URL?: string,
  apiPath?: string,
  adminPath?: string,
  id?: string
) {
  if (id !== undefined) {
    return axios
      .put(`${API_URL}${apiPath}/${id}`, values, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        return err.response.data;
      });
  } else {
    return axios
      .post(`${API_URL}${apiPath}`, values, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        return err.response.data;
      });
  }
}
